import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import {useAuthentification, useSubscriptions} from "hooks"
import Button from "components/molecules/CustomButtons/Button";

const Footer = () => {
  const { t } = useTranslation();
  const {addSubscription} = useSubscriptions()
  const [email,setEmail] = React.useState("")
  const [result,setResult] = React.useState("")
  const {isHost} = useAuthentification()
  const submitNewsletter = async(e) =>{
    e.preventDefault();
    if(email!==""){
      const response = await addSubscription(email);
      setResult(response)
    }else{
      setResult("please fill in your email")
    }

  }
  return (
    <div className="footer">
      <div className="container">
        <div className="footer__header">
          <div className="footer__logo">
            <img src="/images/logo2.png" alt="logo of footer" />
          </div>
         {
           !isHost ?  <div className="footer__host">
           <h4>{t('general.Ready to join us and share your passion?')}</h4>
           <Link to="/becomeHost"><Button>{t('become_a_host')} </Button></Link>
         </div> :
         <div className="footer__host">
         <h4>{t('general.Ready to share your passion?')}</h4>
         <Link to="/AddExperience"><Button>{t('header.addExperience')} </Button></Link>
       </div> 
         }
        </div>
        <div className="footer__desc">
          <div className="footer__sub">
            <label htmlFor="subscribe">{t('Subscribe to our newsletter')}</label>
            <form onSubmit={submitNewsletter}>
            <div className="input">
              <input type="text" id="subscribe" style={{color:"black"}} placeholder="Email address" value={email} onChange={(e)=>setEmail(e.target.value)} />
              <button type="submit" style={{background: "#10455B"}}>
                <svg
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.1543 14.1333L10.9751 10.3125L7.1543 6.49167L8.33346 5.3125L13.3335 10.3125L8.33346 15.3125L7.1543 14.1333Z"
                    fill="white"
                  />
                </svg>
              </button>
            </div>
            {result && <p style={result==="already registered in newsletter" ? {color:"red"} : {color:"green"}}>{result}</p>}
            </form>
          </div>
          <div className="footer__contact">
            <ul>
            <li className="list__title main__color"><Link to="/contact">Contact</Link></li>
              <li className="list__item"><a href="mailto:contact@tabaani.co">contact@tabaani.co</a></li>
              <li className="list__item"><a href="mailto:support@tabaani.co">support@tabaani.co</a></li>
              <li className="list__item"><a href="tel:+21693649679">+216 93 649679</a></li>
            </ul>
          </div>
          <div className="footer__about">
            <ul>
            <li className="list__title main__color"><Link to="/about">{t('about_us')}</Link></li>
              <li className="list__item"><Link to="/about">{t('what_is')} Tabaani</Link></li>
              <li className="list__item"><Link to="/blog">Blogs</Link></li>
              <li className="list__item"><Link to="/team">Team</Link></li>
              <li className="list__item"><Link to="/community">Tabaani Community</Link></li>
            </ul>
          </div>
          <div className="footer__support">
            <ul>
              <li className="list__title main__color"><Link to="/help">{t('support')}</Link></li>
              <li className="list__item"><Link to="/help">Help center</Link></li>
              <li className="list__item"><Link to="/terms">Terms and Conditions</Link></li>
              <li className="list__item"><Link to="/privacy-policy">Privacy Policy</Link></li>
            </ul>
          </div>
        </div>
        <div className="footer__footer">
          <h6>
            {t('general.copywrites')}
            <span className="tabaaniWord">Tabaani</span>{" "}
          </h6>
          <div className="footer__logos">
            <a href="https://www.facebook.com/TabaaniPlatform">
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19.4219 0H2.57812C1.15655 0 0 1.15655 0 2.57812V19.4219C0 20.8435 1.15655 22 2.57812 22H19.4219C20.8435 22 22 20.8435 22 19.4219V2.57812C22 1.15655 20.8435 0 19.4219 0ZM20.2812 19.4219C20.2812 19.8957 19.8957 20.2812 19.4219 20.2812H14.5234V13.2773H17.1785L17.6172 10.6133H14.5234V8.76562C14.5234 8.03623 15.0831 7.47656 15.8125 7.47656H17.5742V4.8125H15.8125C13.6244 4.8125 11.8603 6.58496 11.8603 8.7731V10.6133H9.28125V13.2773H11.8603V20.2812H2.57812C2.10427 20.2812 1.71875 19.8957 1.71875 19.4219V2.57812C1.71875 2.10427 2.10427 1.71875 2.57812 1.71875H19.4219C19.8957 1.71875 20.2812 2.10427 20.2812 2.57812V19.4219Z"
                fill="white"
              />
            </svg>

            </a>
           <a href="https://www.linkedin.com/company/67281472/"> <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.87534 18.1758H3.86752V8.46484H6.87534V18.1758ZM7.17545 5.37093C7.17545 4.39859 6.38657 3.60938 5.41473 3.60938C4.43921 3.60938 3.65234 4.39859 3.65234 5.37093C3.65234 6.3436 4.43921 7.13281 5.41473 7.13281C6.38657 7.13281 7.17545 6.3436 7.17545 5.37093ZM18.1328 12.8332C18.1328 10.2264 17.5821 8.29297 14.5369 8.29297C13.0736 8.29297 12.0913 9.02478 11.6904 9.7858H11.6875V8.46484H8.76562V18.1758H11.6875V13.3542C11.6875 12.0915 12.0089 10.8682 13.5741 10.8682C15.118 10.8682 15.168 12.3122 15.168 13.4344V18.1758H18.1328V12.8332ZM22 19.4219V2.57812C22 1.15646 20.8435 0 19.4219 0H2.57812C1.15646 0 0 1.15646 0 2.57812V19.4219C0 20.8435 1.15646 22 2.57812 22H19.4219C20.8435 22 22 20.8435 22 19.4219ZM19.4219 1.71875C19.8957 1.71875 20.2812 2.10429 20.2812 2.57812V19.4219C20.2812 19.8957 19.8957 20.2812 19.4219 20.2812H2.57812C2.10429 20.2812 1.71875 19.8957 1.71875 19.4219V2.57812C1.71875 2.10429 2.10429 1.71875 2.57812 1.71875H19.4219Z"
                fill="white"
              />
            </svg></a>
          
          <a href="https://www.youtube.com/channel/UCrkjHI_PENVKcgVznffyLVQ">
            <svg
              width="27"
              height="22"
              viewBox="0 0 27 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0)">
                <path
                  d="M17.6558 9.28663L11.6909 6.02286C11.3479 5.8352 10.9425 5.8422 10.6064 6.0414C10.27 6.2408 10.0693 6.59305 10.0693 6.98403V13.4555C10.0693 13.8446 10.2687 14.1963 10.6029 14.3959C10.7773 14.5001 10.9708 14.5524 11.1646 14.5524C11.3422 14.5524 11.5201 14.5086 11.6839 14.4204L17.649 11.2129C18.0031 11.0223 18.2242 10.6542 18.2258 10.2519C18.2273 9.84961 18.0089 9.47985 17.6558 9.28663ZM11.6516 12.6414V7.80471L16.1096 10.2441L11.6516 12.6414Z"
                  fill="white"
                />
                <path
                  d="M26.8013 5.09617L26.8001 5.08381C26.7772 4.86649 26.5496 2.93344 25.6099 1.95023C24.5237 0.793785 23.2922 0.653297 22.7 0.585938C22.651 0.580376 22.6061 0.575226 22.5659 0.56987L22.5187 0.564926C18.9493 0.305374 13.5587 0.269943 13.5047 0.269737L13.4999 0.269531L13.4952 0.269737C13.4412 0.269943 8.05061 0.305374 4.44903 0.564926L4.40145 0.56987C4.36313 0.57502 4.32091 0.579758 4.27497 0.585114C3.68954 0.652679 2.4713 0.793373 1.38201 1.99164C0.486967 2.96434 0.22824 4.85598 0.201667 5.06857L0.198577 5.09617C0.190543 5.1866 0 7.33944 0 9.50072V11.5211C0 13.6824 0.190543 15.8352 0.198577 15.9259L0.200019 15.9395C0.222884 16.1533 0.4503 18.0509 1.38571 19.0345C2.40703 20.1522 3.6984 20.3001 4.393 20.3797C4.5028 20.3922 4.59735 20.4029 4.66182 20.4143L4.72424 20.4229C6.7852 20.619 13.247 20.7156 13.521 20.7196L13.5292 20.7198L13.5374 20.7196C13.5914 20.7193 18.9818 20.6839 22.5513 20.4244L22.5984 20.4194C22.6436 20.4134 22.6942 20.4081 22.7498 20.4023C23.332 20.3405 24.5436 20.2122 25.6179 19.0302C26.5129 18.0573 26.7719 16.1656 26.7982 15.9533L26.8013 15.9257C26.8093 15.835 27.0001 13.6824 27.0001 11.5211V9.50072C26.9999 7.33944 26.8093 5.18681 26.8013 5.09617ZM25.4177 11.5211C25.4177 13.5215 25.243 15.5817 25.2265 15.7708C25.1593 16.2917 24.8864 17.4885 24.4503 17.9625C23.778 18.7023 23.0873 18.7756 22.583 18.8289C22.522 18.8353 22.4656 18.8415 22.4145 18.8479C18.9621 19.0976 13.7749 19.1359 13.536 19.1373C13.268 19.1334 6.90076 19.036 4.90263 18.8504C4.80025 18.8337 4.68963 18.8209 4.57304 18.8077C3.98164 18.74 3.17208 18.6473 2.54957 17.9625L2.53495 17.9469C2.10648 17.5005 1.84137 16.3813 1.77401 15.7769C1.76144 15.634 1.58223 13.5495 1.58223 11.5211V9.50072C1.58223 7.50259 1.7565 5.44471 1.77339 5.25169C1.85352 4.63804 2.13161 3.51373 2.54957 3.0593C3.24253 2.29713 3.97319 2.21267 4.45645 2.15685C4.50259 2.15149 4.54564 2.14655 4.5854 2.1414C8.0881 1.8905 13.3125 1.85321 13.4999 1.85177C13.6874 1.853 18.9099 1.8905 22.3815 2.1414C22.4242 2.14675 22.4707 2.15211 22.5208 2.15788C23.0178 2.21452 23.7691 2.30022 24.4586 3.03561L24.4649 3.04241C24.8934 3.4888 25.1585 4.62753 25.2259 5.24407C25.2378 5.379 25.4177 7.46798 25.4177 9.50072V11.5211Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="27"
                    height="27"
                    fill="white"
                    transform="translate(0 -3)"
                  />
                </clipPath>
              </defs>
            </svg>
            </a>
          <a href="https://www.instagram.com/tabaani.co/">
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.875 0H15.125C18.9214 0 22 3.07862 22 6.875V15.125C22 18.9214 18.9214 22 15.125 22H6.875C3.07862 22 0 18.9214 0 15.125V6.875C0 3.07862 3.07862 0 6.875 0ZM15.125 19.9375C17.7787 19.9375 19.9375 17.7787 19.9375 15.125V6.875C19.9375 4.22125 17.7787 2.0625 15.125 2.0625H6.875C4.22125 2.0625 2.0625 4.22125 2.0625 6.875V15.125C2.0625 17.7787 4.22125 19.9375 6.875 19.9375H15.125Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.5 11C5.5 7.96263 7.96263 5.5 11 5.5C14.0374 5.5 16.5 7.96263 16.5 11C16.5 14.0374 14.0374 16.5 11 16.5C7.96263 16.5 5.5 14.0374 5.5 11ZM7.5625 11C7.5625 12.8948 9.10525 14.4375 11 14.4375C12.8948 14.4375 14.4375 12.8948 14.4375 11C14.4375 9.10388 12.8948 7.5625 11 7.5625C9.10525 7.5625 7.5625 9.10388 7.5625 11Z"
                fill="white"
              />
              <circle cx="16.9126" cy="5.08749" r="0.732875" fill="white" />
            </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Footer);
